/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import styled from 'styled-components';

const Bar = styled.div`
  height: 100%;
  background-color: ${props => props.theme.tvGuide.verticalBar.color};
  z-index: 100;
  margin-left: -2px;
  transition: left 200ms;
  width: 3px;
  pointer-events: none;
`;

// eslint-disable-next-line react/prefer-stateless-function
export default class VerticalBar extends React.PureComponent {
  displayName = 'VerticalBar';

  render() {
    return <Bar />;
  }
}
